<template>
	<v-dialog
	  v-model="modalOpen"
	  max-width="600"
	>
	  <v-card>
      <v-toolbar card dark color="#1f97b9">
        <v-toolbar-title>Realizar Pago</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="btn-close-pago-dialog" dark icon @click="modalOpen = false">
          <v-img :src='require("../../assets/static/img/cerrar.png")' alt="icono de cierre de ventana" max-height="25" contain></v-img>
        </v-btn>
      </v-toolbar>
	    <v-card-text>

      	<v-layout row wrap justify-center align-center>
      		<v-flex sm4 md4 xs12 class="text-xs-center" :class="{'px-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}">
						<v-img :src='require("../../assets/static/img/archive.png")' alt="icono de archivo" max-height="70" contain></v-img>
      		</v-flex>
      		<v-flex sm8 md8 xs12 :class="{'px-0': $vuetify.breakpoint.smAndDown, 'pl-3': $vuetify.breakpoint.mdAndUp}">
						<h3>Realizar pago</h3>
						<h4 class="mb-3">Se ha ingresado una solicitud de pago para el siguiente servicio</h4>
						<p class="ma-0"><b>Número de Servicio: </b> <span v-if="paymentData">{{paymentData.ns_pedido}}</span></p>
						<p class="ma-0"><b>Monto a pagar: </b> <span v-if="paymentData">{{paymentData.amount | CLP}}</span></p>
      		</v-flex>
    		</v-layout>		  
	          <v-divider class="my-3"></v-divider>  	

      	<v-layout row wrap justify-center align-center>
      		<v-flex sm12 md4 xs12 class="text-xs-center">
						<v-img :src='require("../../assets/static/img/webpay-1.png")' alt="imagen de webpay" max-height="70" contain></v-img>
      			<small>Tu pago será procesado de forma segura mediante <b>WebPay Plus</b></small>
      		</v-flex>
      		<v-flex sm12 md8 xs12 justify-center align-center class="text-xs-center">
						<v-btn color="#1f97b9" outline large class="third-step-button mt-3" :disabled="loadingPay || !paymentData || !paymentData.amount || !paymentData.id_pedido" @click="goToPay(paymentData.amount, paymentData.id_pedido)">
							<v-layout row wrap pa-3 justify-center align-center>
								<span v-if="!loadingPay">Realizar Pago</span>
								<v-progress-circular
									v-if="loadingPay"
									:size="21"
									:width="3"
						      indeterminate
						      color="#1f97b9"
						      class="mr-2"
						    ></v-progress-circular> <span v-if="loadingPay">Espera un segundo</span>
							</v-layout>
						</v-btn>
					</v-flex>
				</v-layout>
	    </v-card-text>
	  </v-card>
	</v-dialog>
</template>

<script>
	import * as firebase from 'firebase/app'
	import 'firebase/firestore'
	import cryptoJS from 'crypto-js'
	import axios from 'axios'

  export default {
    name: 'PaymentModal',
    data () {
      return {
        modalOpen: false,
        loadingPay: false,
        paymentData: null,
        requestID: null
      }
    },
    mounted(){
    	console.log(this.$route)
    	if(this.$route.query.idrp){
    		this.requestID = this.$route.query.idrp
    		this.getPaymentRequest(this.$route.query.idrp)
    	}
    },
    methods: {
    	getPaymentRequest(paymentRequestID){
				const db = firebase.firestore()
				const here = this
				db.collection("payment_request").doc(paymentRequestID).get().then(function(doc) {
					if (doc.exists) {
						console.log(doc.data())
						here.modalOpen = true
						here.paymentData = doc.data()
					}
				})
    	},
			goToPay(valor, idPedido){
				const here = this
				this.loadingPay = true
				let db = firebase.firestore()
				db.collection("pagos").add({
					id_pedido: idPedido,
					monto: valor,
					estado: 'Esperando Pago',
					fecha_ingreso: firebase.firestore.FieldValue.serverTimestamp()
				})
					.then(function(docRef) {
						here.payFlow(valor, docRef.id, idPedido)
					})
				  .catch(error => {
				  	console.log("error", error)
						here.loadingPay = false
				  })
			},
			payFlow(valor, idPago, idPedido){
				const here = this
				let flow_params = {
					amount: valor,
					apiKey: '58D1DFFC-908B-43E9-80D0-1LA6424AC4FD', //Producción
					// apiKey: '3C7F5DF0-1742-402A-975C-9F5D29FF5LC2', //Desarrollo
					commerceOrder: idPago,
					email: this.paymentData.user_email,
					/* optional: JSON.stringify({'idPedido': idPedido}), */
					optional: JSON.stringify({'idPedido': idPedido,'tipo': 1, paymentByRequest: this.requestID}),
					paymentMethod: 1,
					subject: 'Pago Transportes DUO: ' + idPedido,
					 urlConfirmation: 'https://us-central1-duoapp-56ef2.cloudfunctions.net/verificarFlow', //Producción
					// urlConfirmation: 'https://us-central1-duoapp-56ef2.cloudfunctions.net/verificarFlowDev', //Desarrollo
					urlReturn: 'https://us-central1-duoapp-56ef2.cloudfunctions.net/finalFlow'
				}
				console.log("flow_params: ", flow_params)
				let data = ''
				let signData = ''
				let cont = 0
				Object.keys(flow_params).forEach(function(key) {
					signData += '&' + key + '=' + flow_params[key]
				  data += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(flow_params[key])
				  cont++
				  if(cont === 9){
						signData = signData.substring(1)
						data = data.substring(1)
				  	here.signAndSend(signData)
				  }
				});

			},
			signAndSend(signData){
				const here = this
				const signature = cryptoJS.HmacSHA256(signData, '83558e934b88eeab5293faa6cf9a4d19aae1b937') //Producción
				// const signature = cryptoJS.HmacSHA256(signData, '66c129032423c9e8fa06e0627fbf1be0c0ef8276') //Desarrollo
				const payFlow = firebase.functions().httpsCallable('initFlow')
				axios({
						method: 'post',
						url: 'https://cors-anywhere.herokuapp.com/https://www.flow.cl/api/payment/create', //Producción
						// url: 'https://cors-anywhere.herokuapp.com/https://sandbox.flow.cl/api/payment/create', //Desarrollo
						/* url: 'https://cors-proxy.htmldriven.com/https://www.flow.cl/api/payment/create', */
						headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			  		data: signData + '&s=' + signature
					})
				  .then(response => {
				    window.location.href = response.data.url + "?token=" + response.data.token
				  })
				  .catch(error => {
				    console.log("Error Flow: ", error)
						here.loadingPay = false
				  })

			},
    }
  }
</script>